const api = "https://api-staging-safmo.fewnu.app/api/v1/"

export default api